import React from "react";
import PropTypes from "prop-types";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./hint.css";

function Hint({ retailer }) {
    const bigDeviceText = gettext("product.buy_area.visit_retailer_site", {
        designer_name: retailer,
    });

    return (
        <div>
            <div className={`${styles.hint} hidden-mobile hidden-tablet`}>
                <SVGIcon name="external-link" />
                <span className={styles.text}>{bigDeviceText}</span>
            </div>
            <div className={`${styles.hint} hidden-desktop`}>
                <SVGIcon name="tap-hand" />
                <span>{gettext("product.buy_area.tap_visit_site")}</span>
            </div>
        </div>
    );
}

export default Hint;

Hint.propTypes = {
    retailer: PropTypes.string,
};

Hint.defaultProps = {
    retailer: "",
};
